import { HttpClient, HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, NgModule, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataBroadcastService } from 'src/app/core/services/broadcast/data-broadcast.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { FileService } from 'src/app/core/services/file-management/file.service';
import { ClonerService } from 'src/app/core/services/helper/cloner.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { IParkerProfileDetail } from 'src/app/shared/interfaces';
// import { DownloadParkersComponent } from '../../parkers/import-export/download-parkers.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { ParkersV2GridViewMainComponent } from '../parkers-v2-grid-views/parkers-v2-grid-view-main/parkers-v2-grid-view-main.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ParkersV2GridViewMassUpdate } from '../parkers-v2-grid-views/parkers-v2-grid-view-mass-update/parkers-v2-grid-view-mass-update.component';
import { ParkersV2GridViewExportComponent } from '../parkers-v2-grid-views/parkers-v2-grid-view-export/parkers-v2-grid-view-export.component';
import { ParkersV2MassupdateComponent } from '../parkers-v2-mass-update/parkers-v2-massupdate.component';
import { DialogDownloadParkersComponent } from '../parker-v2-dialogs/dialog-download-parkers/dialog-download-parkers.component';

type NewType = IParkerProfileDetail;

@Component({
  selector: 'app-parkers-v2-search-results',
  templateUrl: './parkers-v2-search-results.component.html',
  standalone: true,
  imports: [
    MatSlideToggleModule,
    MatExpansionModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    MatTabsModule,
    ParkersV2GridViewMainComponent,
    CommonModule,
    MatSnackBarModule,
    ParkersV2GridViewMassUpdate,
    ParkersV2GridViewExportComponent,
    ParkersV2MassupdateComponent,
  ],
  styleUrl: './parkers-v2-search-results.component.scss',
  providers: [],
})
export class ParkersV2SearchResultsComponent implements OnInit {
  parkers: IParkerProfileDetail[] = [];
  parker: IParkerProfileDetail[] = [];
  filteredParkers: IParkerProfileDetail[] = [];
  filteredParkerDetail?: IParkerProfileDetail | undefined;
  gridFontSize: number = 12;
  currentRowInEditMode: number = -1;
  currentlyActivePaymentRow: number = -1;
  massUpdateDisplay: boolean = false;
  massUpdateTabText: string = 'No Update...';
  gridViewSelection: number = 0;
  numberOfParkers: number = 0;
  queryNumberOfParkers: number = 0;
  parkerQueryResults: any;
  currentFilterSelected: string = '';
  disableSearchButton: boolean = false;
  currentParkerFilter: string = '';
  testBroadcast: string = '';
  numberOfExpiredParkers: number = 0;
  numberOfDuplicateKeyCards: number = 0;
  downloadType: number;
  // fileUrl: string = 'https://localhost:7057/api/file/test.txt';
  fileUrl: string = 'web-apn-dev.azurewebsites.net/api/file/test.txt';
  // https:///
  progress: number = 0;

  message: string;
  allFiles: File[];
  displayDragDropArea: boolean = true;

  @Output() handleFilterParkerEvent: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private router: Router,
    private clonerService: ClonerService,
    private dataBroadcastService: DataBroadcastService,
    public parkerStateService: ParkerStateService,
    public dialog: MatDialog,
    private http: HttpClient,
    private fileService: FileService,
  ) {
    this.filteredParkers = this.parkerStateService.getFilteredParkerData();
    this.parkers = this.parkerStateService.getParkerQueryResults();
    this.numberOfParkers = this.parkerStateService.getFilteredParkerData().length;
    this.queryNumberOfParkers = this.parkerStateService.getParkerQueryResults().length;
    this.parkerStateService.parkerQueryPerformed = false;
  }

  ngOnInit(): void {
    if (this.parkerStateService.parkerEnableMode) {
      this.onReturnFromEnableModeParkerFilter();
    }

    if (this.parkerStateService.getRemoveParkerProfileQueryResults()) {
      this.parkerStateService.resetQueryData();
    } else {
      if (this.parkers !== undefined) {
        this.filteredParkers = this.clonerService.deepClone(this.parkers);
        this.numberOfParkers = this.parkers.length;
      }

      if (this.parkerStateService.parkerEnableMode) {
        this.filteredParkers = this.parkerStateService.getFilteredParkerData();
        this.parkers = this.parkerStateService.getParkerQueryResults();
        this.queryNumberOfParkers = this.parkerStateService.queryNumberOfParkerResults;
        this.currentParkerFilter = this.parkerStateService.currentParkerFilter;
      }
    }
  }

  download(fileName: string): void {
    // this.fileService.download(fileName).subscribe((event: any) => {
    //
    //   if (event.type === HttpEventType.UploadProgress){
    //     if(event.total !== undefined)
    //       this.progress = Math.round(100 * event.loaded / event.total);
    //     else
    //       this.progress = 0;
    //   }
    //   else if (event.type === HttpEventType.Response) {
    //
    //     this.downloadFile(event, fileName);
    //   }
    // });
  }

  testDelete(): void {
    this.parkerStateService.filteredParkers = [];
  }

  downloadFile = (data: HttpResponse<Blob>, fileName: string) => {
    const downloadedFile = new Blob([data.body!], { type: data.body!.type });
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = fileName;
    a.href = URL.createObjectURL(downloadedFile);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  };

  // downloadFile(fileName: string): void{

  //   this.fileService.download(fileName).subscribe((response) => {
  //     let resp: any;
  //     //this.downloadTheFile(response);
  //     resp = response;
  // });

  // }

  uploadFile = (files: any) => {
    if (files.length === 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.http
      .post('https://localhost:7057/api/file/upload', formData, { reportProgress: true, observe: 'events' })
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            if (event.total !== undefined) this.progress = Math.round((100 * event.loaded) / event.total);
            else this.progress = 0;
          } else if (event.type === HttpEventType.Response) {
            this.message = 'Upload success.';
          }
        },
        error: (err: HttpErrorResponse) => {
          this.message = err.message;
        },
      });
  };

  downloadTheFile(data: any) {
    const downloadedFile = data;
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = 'https://localhost:7057/api/file/profile-text.xlsx';
    a.href = URL.createObjectURL(downloadedFile);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  }

  onReturnFromEnableModeParkerFilter(): void {
    this.currentParkerFilter = this.parkerStateService.currentParkerFilter;
    if (this.currentParkerFilter != '') {
      this.currentFilterSelected = this.currentParkerFilter;
      this.onFilterParkerData(this.currentParkerFilter);
    }
  }

  ngOnChanges(): void {
    this.filteredParkers = this.clonerService.deepClone(this.parkers);
  }

  onParkerDownload(): void {
    const dialogRef = this.dialog.open(DialogDownloadParkersComponent, {
      data: { downloadId: this.downloadType },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.downloadType = result;
      this.parkerProfileDownloadStart(this.downloadType);
    });
  }

  parkerProfileDownloadStart(downloadType: number): void {
    let fileName: string = 'parkers-lot';
    let downloadTypeDescription: string = '';

    if (downloadType == 1) {
      downloadTypeDescription = 'current-query-results';
    } else if (downloadType == 2) {
      downloadTypeDescription = 'active-profiles';
    } else if (downloadType == 3) {
      downloadTypeDescription = 'all-profiles';
    } else
      this.download(
        `${fileName}-${this.parkerStateService.filteredParkers[0].lotNumber}-${downloadTypeDescription}.csv`,
      );
  }

  onFilterParkerData(command: string): void {
    this.parkerStateService.currentParkerFilter = command;
    this.currentFilterSelected = command;
    this.handleFilterParkerEvent.emit(command);
  }

  isFilterSelected(filterCommand: string): boolean {
    let isSelected: boolean = false;

    isSelected = this.currentFilterSelected === filterCommand;

    return isSelected;
  }

  onFontSizeChange(sizeIncreaseDecrease: string): void {
    this.dataBroadcastService.fontSizeBroadcast.next(sizeIncreaseDecrease);
  }

  onToggleDisplayMassUpdate(): void {
    this.massUpdateDisplay = !this.massUpdateDisplay;
  }

  onToggleShowGridColumns(): void {
    let gridTypeSelected: any;

    var e = document.getElementById('selectQSRLayout') as HTMLSelectElement;
    var sel = e.selectedIndex;
    var opt = e.options[sel];
    gridTypeSelected = (<HTMLOptionElement>opt).value;

    this.gridViewSelection = +gridTypeSelected;
  }

  onClearFilterData(): void {
    this.currentFilterSelected = '';
    this.currentParkerFilter = '';
    this.parkerStateService.currentParkerFilter = '';
    this.onFilterParkerData('ALL');
  }

  onToggleMassUpdateText(): void {
    if (this.massUpdateTabText == 'No Update...') this.massUpdateTabText = '23 Parkers Updated on Last Update';
    else this.massUpdateTabText = 'No Update...';
  }

  onNavigateToAddParker(): void {
    this.router.navigate([`/parker/new`]);
  }

  onParkerImport(): void {
    this.router.navigate([`/parker/101/import`]);
  }

  onNavigateToParkersGroupUpdate(parkerId: string): void {
    let data = { parkerId: parkerId };
    this.router.navigate([`/parkersgroupupdate/${parkerId}`]);
  }

  onNavigateToParkerEdit(parkerId: string): void {
    this.storeParkerData(parkerId);
    let data = { parkerId: parkerId };
    this.router.navigate([`/parker/${parkerId}/details`]);
  }

  onNavigateToParkersDetail(parkerId: string): void {
    this.storeParkerData(parkerId);
    let data = { parkerId: parkerId };
    this.router.navigate([`/parker/${parkerId}/details`]);
    //this.router.navigate([`/parker`]);
  }

  storeParkerData(parkerId: string): void {
    this.parker = this.parkers;
    this.filteredParkerDetail = this.parker.find((x) => x.parkerId == parkerId);
    if (this.filteredParkerDetail != undefined) this.parkerStateService.setParkerDetail(this.filteredParkerDetail);
  }

  getQSRRowBackgroundColor(rowNumber: number): string {
    if (this.currentlyActivePaymentRow === rowNumber) {
      return 'yellow';
    } else {
      if (rowNumber % 2 === 1) return '#e1e1e4';
      else return '#fff';
    }
  }
}
